import { getSearchParam } from ".";
import CryptoJS from "crypto-js";
/*
小米
stuHR7Hsti1iDJO3
oppo
vivo
ke8sw4s9
*/
let default_key = "stuHR7Hsti1iDJO3";
let key_length = 16;
const { hostName } = useHostName();
if (domainMap["v-ls"]?.includes(hostName)) {
  default_key = "ke8sw4s9";
  key_length = 8;
}

class AesDecryptor {
  private readonly key: CryptoJS.lib.WordArray;
  private readonly base64WithUrl: boolean;

  constructor(key: string = default_key, base64WithUrl: boolean = true) {
    this.key = CryptoJS.enc.Utf8.parse(key.padEnd(key_length, "\0"));
    this.base64WithUrl = base64WithUrl;
  }

  private normalizeBase64(data: string): string {
    if (!this.base64WithUrl) return data;

    return data
      .replace(/-/g, "+")
      .replace(/ /g, "+")
      .replace(/_/g, "/")
      .padEnd(data.length + ((4 - (data.length % 4)) % 4), "=");
  }

  decryptStr(encryptedStr: string): string | null {
    try {
      const normalizedBase64 = this.normalizeBase64(encryptedStr);
      const encryptedData = CryptoJS.enc.Base64.parse(normalizedBase64);
      const cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: encryptedData });

      const decrypted = CryptoJS.AES.decrypt(cipherParams, this.key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });

      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Decryption failed:", error);
      return null;
    }
  }
}

export function get_gallery_info(): string {
  let gallery_info = getSearchParam("gallery_info");
  if (domainMap["v-ls"]?.includes(hostName)) {
    gallery_info = getSearchParam("g_v");
  }
  if (!gallery_info) {
    // console.log("gallery_info parameter not found");
    return "";
  }

  const decryptor = new AesDecryptor();
  const decrypted = decryptor.decryptStr(gallery_info);

  if (decrypted) {
    // console.log("Decryption successful:", decrypted);
    return decrypted;
  }

  // console.log("Decryption failed for gallery_info:", gallery_info);
  return "";
}
